import {
	CONSTELLATION_CENTER,
	CONSTELLATION_DOT_COUNT,
	CONSTELLATION_FORMATION_RADIUS,
} from '../constants';
import type { ConstellationDot } from '../types';
import { getStableVariation } from './poseHelpers';
import { getRingCoordinates, getRingPoint, INNER_RING_DOT_COUNT } from './ring';

type GyreDotInput = Readonly<{
	color: string;
	index: number;
	timeSeconds: number;
}>;

const GLOW_DWELL_SECONDS = 0.6;
const GLOW_SEQUENCE_OFFSET = 31;
const INNER_RING_RADIUS_RATIO = 0.52;
const OUTER_RING_RADIUS_RATIO = 1.05;
const INNER_RING_ROTATION_RADIANS_PER_SECOND = -0.59;
const OUTER_RING_ROTATION_RADIANS_PER_SECOND = 0.91;
const RESTING_BRIGHTNESS = 0.58;

const getGlowingDotIndex = (timeSeconds: number): number => {
	const step = Math.floor(timeSeconds / GLOW_DWELL_SECONDS);
	const selectedIndex = Math.floor(
		getStableVariation(step + GLOW_SEQUENCE_OFFSET) * CONSTELLATION_DOT_COUNT,
	);
	const previousIndex = Math.floor(
		getStableVariation(step + GLOW_SEQUENCE_OFFSET - 1) * CONSTELLATION_DOT_COUNT,
	);

	return selectedIndex === previousIndex
		? (selectedIndex + 1) % CONSTELLATION_DOT_COUNT
		: selectedIndex;
};
export const createGyreDot = ({ color, index, timeSeconds }: GyreDotInput): ConstellationDot => {
	const { count, ringIndex } = getRingCoordinates(index);
	const isCenterDot = index === 0;
	const isInnerRing = count === INNER_RING_DOT_COUNT;
	const isGlowing = index === getGlowingDotIndex(timeSeconds);
	const radiusRatio = isInnerRing ? INNER_RING_RADIUS_RATIO : OUTER_RING_RADIUS_RATIO;
	const rotationSpeed = isInnerRing
		? INNER_RING_ROTATION_RADIANS_PER_SECOND
		: OUTER_RING_ROTATION_RADIANS_PER_SECOND;
	const point = isCenterDot
		? { x: CONSTELLATION_CENTER, y: CONSTELLATION_CENTER }
		: getRingPoint(
				ringIndex,
				count,
				CONSTELLATION_FORMATION_RADIUS * radiusRatio,
				timeSeconds * rotationSpeed,
			);

	return {
		...point,
		brightness: isGlowing ? 1 : RESTING_BRIGHTNESS,
		color,
		glowStrength: isGlowing ? 1 : 0,
		scale: 1,
	};
};
